export default {
  docs: [],
  totalDocs: 0,
  search: "",
  role: "all",
  active: "all",
  loading: false,
  page: 1,
  totalPages: 0,
  sort: "-createdAt",
  filter: "future",
};
